import type { AdminUserSession } from "../DataAccess/AdminUserDataService";
import ConstantMessage from "./ConstantMessage";

export default class SessionHelper {
  public static SetSession(AdminUser: AdminUserSession | null) {
    if (AdminUser == null) {
      localStorage.removeItem('User');
      return;
    }
    localStorage.setItem('User', JSON.stringify(AdminUser))
  }
  public static GetSession(): AdminUserSession | null {
    var item = localStorage.getItem('User');
    if (!item || item === 'null') {
      return null;
    }

    return JSON.parse(item) as AdminUserSession;
  }

  public static Logout(props: Pick<import('react-router-dom').RouteComponentProps, 'history'>) {
    SessionHelper.SetSession(null);
    props.history.push(ConstantMessage.LoginPagePath)
  }
}
